import { u21CreateSlice } from 'app/shared/thunk/u21CreateSlice';
import { RtmRuleBuilderFormValues } from 'app/modules/detectionModels/components/RtmRuleBuilderForm/models';
import { PayloadAction } from '@reduxjs/toolkit';
import { DEFAULT_DROPDOWN_BUILDER_FORM_VALUES_WITH_NO_CONDITIONS } from 'app/modules/detectionModels/constants';
import { RtrTypes } from 'app/modules/rulesAdvanced/models';
import { DEFAULT_RTM_FORM_VALUES } from 'app/modules/detectionModels/components/RtmRuleBuilderForm/constants';

const RTM_RULE_BUILDER_FORM_VALUES = 'RTM_RULE_BUILDER_FORM_VALUES';
interface RtmRuleBuilderFormValuesState {
  matchlistEnabled: boolean;
  rtrType?: RtrTypes;
  formValues: RtmRuleBuilderFormValues;
}

const initialState: RtmRuleBuilderFormValuesState = {
  matchlistEnabled: true,
  rtrType: RtrTypes.BASIC,
  formValues: DEFAULT_RTM_FORM_VALUES,
};

const rtmRuleBuilderFormValuesSlice = u21CreateSlice({
  name: RTM_RULE_BUILDER_FORM_VALUES,
  initialState,
  reducers: {
    resetRtmFormValues: (draft) => {
      Object.assign(draft, initialState);
    },
    setCurrentFormValues: (
      draft,
      { payload }: PayloadAction<RtmRuleBuilderFormValues>,
    ) => {
      draft.formValues = payload;
    },
    setRtrType: (draft, { payload }: PayloadAction<RtrTypes>) => {
      draft.rtrType = payload;
    },
    initializeBehaviorOverTimeFormValues: (draft) => {
      draft.formValues.behaviorOverTimeDropdownBuilderFormValues =
        DEFAULT_DROPDOWN_BUILDER_FORM_VALUES_WITH_NO_CONDITIONS;
    },
  },
});

export const RTM_RULE_BUILDER_FORM_VALUES_SLICE_NAME =
  rtmRuleBuilderFormValuesSlice.name;
export const {
  resetRtmFormValues,
  setCurrentFormValues,
  setRtrType,
  initializeBehaviorOverTimeFormValues,
} = rtmRuleBuilderFormValuesSlice.actions;
export default rtmRuleBuilderFormValuesSlice.reducer;
